import {KeyVaultRef, Office, Role, User} from "../../api/Model";
import Permission from "./Permission";

export type AccessLevel = 'guest' | 'vault-manager' | 'office-admin' | 'system-admin';

const vaultManagerPermissions = [
    Permission.Offices_Read,
    Permission.WorkSites_Read,
    Permission.Employees_Read,
    Permission.KeyVaults_Read,
    Permission.KeyTags_Read,
    Permission.KeyData_Read,
    Permission.KeyData_Operate,
];
const officeAdminPermissions = [
    ...vaultManagerPermissions,
    Permission.Employees_Admin,
    Permission.Teams_Read,
    Permission.KeyData_Admin,
    Permission.KeyTags_Admin,
    Permission.KeyVaults_Admin,
    Permission.VisitReports_Read,
    Permission.VisitReports_Admin,
    Permission.Neighbourhoods_Read,
    Permission.Neighbourhoods_Admin,
    Permission.Desks_Read,
    Permission.Floors_Read,
    Permission.SeatingPlans_Read,
    Permission.SeatingPlans_Admin,
    Permission.SeatingPlans_Execute,
    Permission.NewJoiners_Read,
    Permission.NewJoiners_Admin,
    Permission.NewJoinerChecklistItems_Read,
    Permission.NewJoinerChecklistItems_Admin,
    Permission.SlackSettings_Read,
    Permission.SlackSettings_Admin,
];
const systemAdminPermissions = [
    ...officeAdminPermissions,
    Permission.UserRoles_Read,
    Permission.UserRoles_Admin,
    Permission.PermanentTokens_Read,
    Permission.PermanentTokens_Admin,
    Permission.Offices_Admin,
    Permission.WorkSites_Admin,
    Permission.GlobalKeyVaults_Read,
    Permission.ClientLoggers_Admin,
];

export const rolePermissions: Record<AccessLevel, Set<Permission>> = {
    'guest': new Set(),
    'vault-manager': new Set(vaultManagerPermissions),
    'office-admin': new Set(officeAdminPermissions),
    'system-admin': new Set(systemAdminPermissions),
}

export function rolesOf(user: User | null): readonly Role[] {
    return user?.roles ?? [];
}

export function officeIdOfRole(role: Role): Office['id'] | null {
    switch (role.type) {
        case "guest":
            return null;
        case 'vault-manager':
        case 'office-admin':
            return role.officeId;
        case 'system-admin':
            return null;
    }
}

export function vaultIdOfRole(role: Role): KeyVaultRef['id'] | null {
    switch (role.type) {
        case "guest":
            return null;
        case 'vault-manager':
            return role.vaultId;
        case 'office-admin':
        case 'system-admin':
            return null;
    }
}
